import { ref } from 'vue'
import { getCSRFToken } from '../config/cvConfig.js'

export const SYNC_TYPE_CONFIG = {
  experience: {
    endpoint: '/api/master_experience_entries',
    paramKey: 'master_experience_entry',
    masterIdField: 'masterExperienceEntryId',
    toPayload: (e) => ({
      job_title: e.jobTitle || '',
      company: e.company || '',
      company_url: e.companyUrl || '',
      location: e.location || '',
      employment_type: e.employmentType || '',
      company_description: e.companyDescription || '',
      start_month: e.startMonth || null,
      start_year: e.startYear ? parseInt(e.startYear) : null,
      end_month: e.endMonth || null,
      end_year: e.endYear ? parseInt(e.endYear) : null,
      is_current: e.isCurrent || false,
      base_bullet_points: (e.bulletPoints || []).filter(p => p?.trim())
    })
  },
  education: {
    endpoint: '/api/master_education_entries',
    paramKey: 'master_education_entry',
    masterIdField: 'masterEducationEntryId',
    toPayload: (e) => ({
      institution: e.institution || '',
      location: e.location || '',
      program_name: e.programName || '',
      program_type: e.programType || '',
      gpa: e.gpa || '',
      start_month: e.startMonth || null,
      start_year: e.startYear ? parseInt(e.startYear) : null,
      end_month: e.endMonth || null,
      end_year: e.endYear ? parseInt(e.endYear) : null,
      is_current: e.isCurrent || false,
      base_bullet_points: (e.bulletPoints || []).filter(p => p?.trim())
    })
  },
  activity: {
    endpoint: '/api/master_activities',
    paramKey: 'master_activity',
    masterIdField: 'masterActivityId',
    toPayload: (e) => ({
      organization: e.organization || '',
      role: e.role || '',
      location: e.location || '',
      activity_type: e.activityType || '',
      url: e.url || '',
      start_month: e.startMonth || null,
      start_year: e.startYear ? parseInt(e.startYear) : null,
      end_month: e.endMonth || null,
      end_year: e.endYear ? parseInt(e.endYear) : null,
      is_current: e.isCurrent || false,
      base_bullet_points: (e.bulletPoints || []).filter(p => p?.trim())
    })
  }
}

export function useSyncToProfile() {
  const isSyncing = ref(false)
  const syncError = ref(null)

  async function syncEntry({ entry, entryType, mode, variantLabel }) {
    const { endpoint, paramKey, masterIdField, toPayload } = SYNC_TYPE_CONFIG[entryType]
    const masterEntryId = entry[masterIdField]

    isSyncing.value = true
    syncError.value = null

    try {
      const url = mode === 'variant' ? `${endpoint}/${masterEntryId}/create_variant` : endpoint
      const payload = toPayload(entry)
      if (mode === 'variant') payload.variant_label = variantLabel

      const resp = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': getCSRFToken(),
          Accept: 'application/json'
        },
        body: JSON.stringify({ [paramKey]: payload })
      })

      const data = await resp.json()
      if (!data.success) throw new Error(data.errors?.join(', ') || data.message || 'Sync failed')

      const masterEntry = data[`master_${paramKey.replace('master_', '')}`] || data.master_experience_entry || data.master_education_entry || data.master_activity
      return masterEntry
    } catch (err) {
      syncError.value = err.message
      throw err
    } finally {
      isSyncing.value = false
    }
  }

  return { isSyncing, syncError, syncEntry }
}
